import { ResourceHelperService } from "../resource-helper.service";

export class ChargeAccountDeviceMappingsService {

  public chargeAccountDeviceMappingsResource: InterACT.Interfaces.IResource<InterACT.Interfaces.ChargeAccounts.ChargeAccountDeviceMappingsResponse>;

  constructor($resource, private resourceHelperService: ResourceHelperService) {
    this.chargeAccountDeviceMappingsResource = $resource(
      'api/charge-account-device-mappings',
      undefined,
      {
        update: {
          method: 'GET'
        }
      }
    );
  }

  /**
   * Retrieves list of  Charge Account Device Mappings
   *
   * @param page The number of the page of data to be retrieved
   * @param perPageCount The number of items per page to be retrieved
   * @param queryString The query to search for Charge Account Device Mappings
   *
   * @returns A promise of a ChargeAccountDeviceMappingsResponse
   */
  public getChargeAccountDeviceMappings(page: number, perPageCount: number, queryString: string){
    const options = this.resourceHelperService.buildRequestOptions(page, perPageCount, queryString);
    return this.chargeAccountDeviceMappingsResource.get(options).$promise.then((response) => {
      return response.chargeAccountDeviceMappings.map(withMeta => withMeta.chargeAccountDeviceMapping);
    });
  }
}
